import { render } from "./TwoAxleTractorThreeAxleSemitrailer.vue?vue&type=template&id=039b7c08&scoped=true&ts=true"
import script from "./TwoAxleTractorThreeAxleSemitrailer.vue?vue&type=script&lang=ts"
export * from "./TwoAxleTractorThreeAxleSemitrailer.vue?vue&type=script&lang=ts"

import "./TwoAxleTractorThreeAxleSemitrailer.vue?vue&type=style&index=0&id=039b7c08&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039b7c08"]])

export default __exports__